import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from '../../storage/storage.service';
import { Storage_Keys } from '../../storage/storage.keys';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class Interceptor {
  constructor(
    private storage: StorageService,
    private router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const savedData = this.storage.getSavedData();
    let header = {};
    if (savedData && savedData[Storage_Keys.authtoken]) {
      header = {
        "Authorization": savedData[Storage_Keys.authtoken]
      };
    }

    const updatedRequest = request.clone({
      headers: new HttpHeaders(header)
    });
    return next.handle(updatedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
        }, (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status == 401) {
              this.storage.clearStorageForLogout();
              // this.commonService.errorToast('Session expired!');
              localStorage.clear();
              this.router.navigate(['/login']);
            }
          }
        }
      )
    );
  }
}
